
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CloseSVG = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.9442 12L22.5972 3.34792C23.1343 2.81079 23.1343 1.93994 22.5972 1.40285C22.06 0.865717 21.1892 0.865717 20.6521 1.40285L12 10.0558L3.34792 1.40285C2.81079 0.865717 1.93994 0.865717 1.40285 1.40285C0.86576 1.93998 0.865717 2.81083 1.40285 3.34792L10.0558 12L1.40285 20.6521C0.865717 21.1892 0.865717 22.0601 1.40285 22.5972C1.93998 23.1342 2.81083 23.1343 3.34792 22.5972L12 13.9442L20.652 22.5972C21.1892 23.1343 22.06 23.1343 22.5971 22.5972C23.1342 22.06 23.1342 21.1892 22.5971 20.6521L13.9442 12Z" fill="current" stroke="current"/>
</svg>);

export const CloseIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CloseSVG} {...props} />
);
